import styled from "@emotion/styled";

import { fontRoboto, fontRobotoCondensed } from "shared/lib/styles";

export const Container = styled.div`
  display: grid;
  grid-template:
    "Title Image" min-content
    "Description Image" min-content
    / auto 60px;
  gap: 4px 12px;
  align-items: center;

  color: #000000;
  font-family: ${fontRobotoCondensed};
`;

export const Title = styled.div`
  grid-area: Title;

  color: #000000;
  font-weight: 700;
  font-size: 18px;
  font-family: ${fontRobotoCondensed};
  line-height: 25.2px;
`;

export const Description = styled.div`
  grid-area: Description;

  font-weight: 400;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: 14px;
`;

export const ImageContainer = styled.div`
  grid-area: Image;
`;
